import {Router, Route, Switch, Redirect} from 'react-router-dom';
import {Provider} from 'react-redux';
import {store} from './store';
import {history} from './helpers/history';

import ErrorBoundary from './com/errorBoundary/ErrorBoundary';

import ReduxErrorsHandler from './components/reduxErrorsHandler/ReduxErrorsHandler';

import './App.scss';

import AuthScreen from './components/auth/AuthScreen';
import React, {useEffect} from "react";
import {ThemeProvider, createTheme, Theme } from '@mui/material/styles';
import {
    UploadingPdfAndCreateFlyer
} from "./components/xCircularLandingPage/uploadingPdfAndCreateFlyer/uploadingPdfAndCreateFlyer";
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'react-phone-number-input/style.css'
import {Main} from "./components/editor/main/main";

declare module '@mui/styles/defaultTheme' {
    interface DefaultTheme extends Theme {}
}


const theme = createTheme({
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    minWidth: 'auto',
                    padding: '0',
                    textTransform: `none`
                },
            },
        },
    },
});

const App = () => {

    const projectUrlPath = `/flyersCatalog`;
    // const projectUrlPath = document.location.pathname.indexOf('flipbookEditor') > -1 ? `/flipbookEditor` : `/flyersCatalog`
    useEffect(() => {
        window.onbeforeunload = function () {
            sessionStorage.clear();
        };

        return () => {
            window.onbeforeunload = null;
        };
    }, []);
    return (
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <ErrorBoundary>
                    <Router history={history}>
                        <Switch>
                            <Route path="/xCircularLandingPage/createFlyer" exact
                                   component={UploadingPdfAndCreateFlyer}/>
                            {/*<Route path="/iframe" exact component={Test}/>*/}
                            <Route
                                path={'/flyersCatalog/:targetFlyerId?/:tabName?'}
                                component={Main}
                            >
                            </Route>

                            <Route path="/auth/:projectName/:screenName/:userId?/:userEmail?/:token?" exact
                                   component={AuthScreen}/>
                            {/*<Route path="/auth/completeRegistration/:userId/:userEmail/:token"*/}
                            {/*       component={AuthScreen}/>*/}
                            {/*<Route path="/resetPassword/:userId/:token" component={AuthScreen}/>*/}
                            {/*<PrivateRoute path="/flipbookEditor/:flyerId?" exact*/}
                            {/*              component={FlippingFlyersCatalogScreen} setTabsState={() => {}}/>*/}
                            <Redirect from="*" to={projectUrlPath}/>
                        </Switch>
                    </Router>
                </ErrorBoundary>
            </ThemeProvider>
            <ReduxErrorsHandler/>

        </Provider>


    );
}

export default App;